import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { AwareAutoCompleteComponent } from '../autocomplete-2/autocomplete-2.component';
import { AutoCompleteComponent } from '../autocomplete/autocomplete.component';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BaseDialogComponent } from '@helpers/base';

@Component({
    selector: 'finder-dialog',
    templateUrl: './finder.dialog.html',
    styleUrls: ['./dialog.scss'],
    standalone: true,
    imports: [MatToolbarModule, MatDialogModule, MatButtonModule, MatIconModule, NgIf, AutoCompleteComponent, AwareAutoCompleteComponent],
})
export class FinderDialog extends BaseDialogComponent {
    public title: string;
    public message: string;

    constructor(
        public dialogRef: MatDialogRef<FinderDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        super(dialogRef);

        this.title = this.data.title;
        this.message = this.data.message;
    }

    onSelect(val) {
        this.dismiss(val);
    }
}
